import { Preloader } from "../../Common/Preloader";
import { ConfirmBankAccountForm } from "../../customer-cab/ConfirmBankAccountForm";
import { CRUDEntity } from "../abstracts/CRUDEntity";
import { EntityModalForm } from "../abstracts/mixins/EntityModalForm";
import { FormActions } from "../abstracts/mixins/FormActions";
import { PaymentMethodInterface } from "../abstracts/mixins/PaymentMethodInterface";

export const BankAccount = (() => {

    return class BankAccount extends CRUDEntity {

        constructor(id=null, urlRoot = '/customer/bank-accounts', sectionRootUrl = '/customer') {
            super();
            this.entityClass = 'bank_account';
            this.urlRoot = urlRoot;
            this.sectionRootUrl = sectionRootUrl;
            this.id = id;

            Object.assign(BankAccount.prototype, FormActions);
            Object.assign(BankAccount.prototype, EntityModalForm);
            Object.assign(BankAccount.prototype, PaymentMethodInterface);

            BankAccount.prototype.collectDataInForm = function(formId) {
                const form = $(`#${formId}`);

                const account_number = form.find('input[name=account_number]').val();
                const bank = form.find('input[name=bank]').val();
                const request_type = 'bank_account';
                const routing_number = form.find('input[name=routing_number]').val();
                const type = form.find('input[name="type"]:checked').val();
                const customer_id = form.find('input[name=customer_id]').val();

                return { account_number, bank, request_type, routing_number, type, customer_id };
            }

            BankAccount.prototype.delete = async ()=>{
                let response = await super.delete();
                if(response.ok){
                    const row = $(`#bank_account-stafter-table tr[data-id="${this.id}"][data-entity="bank_account"]`)
                    if(row.length) row.remove()
                }
            }
        }

        agreementVerificationForm() {
            const url = `${this.urlRoot}/${this.id}/verify/agreement-form`;
            fetch(url, { method: 'GET' })
                .then(response => response.text())
                .then(formHTML => {
                    this.pasteForm(formHTML);
                    $('.modal-backdrop').first().remove();
                    $('#init_verification-modal').modal('show');
                });
        }

        manuallyVerificationStart() {
            const url = `${this.urlRoot}/${this.id}/verify/agreement-form-manually`;
            fetch(url, { method: 'GET' })
                .then(response => response.text())
                .then(formHTML => {
                    this.pasteForm(formHTML);
                    $('.modal-backdrop').first().remove();
                    $('#form-container .modal').modal('show');
                    if($('#verify').length)
                        ConfirmBankAccountForm.init(this);
                    if($('#different-verify').length)
                        $('#different-verify').off('click').on('click', this.initDifferentVerificationManually.bind(this))
                });
        }

        async initVerificationProcess() {
            const url = `${this.urlRoot}/${this.id}/verify/init`;
            const preloader = new Preloader('init_verification-modal', true);
            preloader.setMessage('Wait until verification process started');
            preloader.open();
            const response = await fetch(url, { method: 'POST' });

            const json = await response.json();
            this.pasteForm(json.modal);
            $('#init_verification-modal').modal('hide');
            $('.modal-backdrop').first().remove();

            preloader.close();

            if (response.ok) {
                $('#form-container .modal').modal('show');
            } else {
                $('#failed_verification-modal').modal('show');
            }
        }

        async initDifferentVerificationManually(){
            const url = `${this.urlRoot}/${this.id}/verify/init-different`;
            const preloader = new Preloader('verify_bank_account-modal', true);
            preloader.setMessage('Please wait...');
            preloader.open();
            const response = await fetch(url, { method: 'POST' });
            const json = await response.json();
            preloader.close();
            this.pasteForm(json.modal);
            $('.modal-backdrop').first().remove();
            $('#form-container .modal').modal('show');
        }

        async getVerificationForm() {
            const url = `${this.urlRoot}/${this.id}/verify/form`;

            const verificationForm = await fetch(url, { method: 'GET' });
            const html = await verificationForm.text();

            this.pasteForm(html);
            $('#init_verification-modal').modal('hide');
            $('.modal-backdrop').first().remove();
            $('#form-container .modal').modal('show');
            ConfirmBankAccountForm.init(this);
            if($('#different-verify').length)
                $('#different-verify').off('click').on('click', this.initDifferentVerificationManually.bind(this))
        }

        async patchCheckoutVerification(stripePaymentMethodId, paymentIntentID, connectedAccount = null) {
            const url = `${this.urlRoot}/${this.id}/verify/checkout-complete`;

            const response = await fetch(url, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    payment_intent: paymentIntentID,
                    payment_method: stripePaymentMethodId,
                    connected_acc: connectedAccount
                })
            });

            if (!response.ok) {
                throw new Error('BizBaby could not save the bank verification result.');
            }

            return response;
        }
    }
})();
